/* eslint-disable no-console */

import { register } from "register-service-worker";

// 節流控制：避免使用者操作頻繁時重複觸發 update check
let _lastCheckTime = 0;
const CHECK_INTERVAL_MS = 30 * 1000; // 最多每 30 秒 check 一次

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    /**
     * 偵測到 SW 有新版本（waiting 狀態）時觸發。
     * 因為 vue.config.js 已設定 skipWaiting: true，新版 SW 裝完後會自動接管，
     * 下次換頁或重新開啟就是新版。不重刷、也不提示（2026-10-30 拿掉底部的「有新版本」通知）；
     * 換頁時舊版檔案已被刪掉的情況，router 的 ChunkLoadError 處理會自動重新載入。
     */
    updated(registration) {
      console.log("[SW] 偵測到新版本，下次載入生效。");
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    },

    registered(registration) {
      console.log("[SW] 已成功註冊。");

      // 暴露主動 update check 的方法供外部呼叫（App.vue 裡的使用者操作偵測）
      window.__swCheckUpdate = () => {
        const now = Date.now();
        if (now - _lastCheckTime < CHECK_INTERVAL_MS) return; // 節流
        _lastCheckTime = now;
        registration.update().catch((err) => {
          console.warn("[SW] update check failed:", err);
        });
      };
    },

    ready() {
      console.log("[SW] App 正由 Service Worker 從快取提供服務。");
    },
    cached() {
      console.log("[SW] 內容已快取，可離線使用。");
    },
    updatefound() {
      console.log("[SW] 正在下載新版本...");
    },
    offline() {
      console.log("[SW] 目前離線，App 以快取版本運行。");
    },
    error(error) {
      console.error("[SW] Service Worker 註冊失敗:", error);
    },
  });
}
